import { render, staticRenderFns } from "./VirtualScroll.vue?vue&type=template&id=11dfd8fe&scoped=true&"
import script from "./VirtualScroll.vue?vue&type=script&lang=js&"
export * from "./VirtualScroll.vue?vue&type=script&lang=js&"
import style0 from "./VirtualScroll.vue?vue&type=style&index=0&id=11dfd8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dfd8fe",
  null
  
)

export default component.exports